/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutenglishmissing3Inputs */

const en_organizeraboutenglishmissing3 = /** @type {(inputs: Organizeraboutenglishmissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No English text yet.`)
};

const de_organizeraboutenglishmissing3 = /** @type {(inputs: Organizeraboutenglishmissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Text auf Englisch.`)
};

/**
* | output |
* | --- |
* | "No English text yet." |
*
* @param {Organizeraboutenglishmissing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutenglishmissing3 = /** @type {((inputs?: Organizeraboutenglishmissing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutenglishmissing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutenglishmissing3(inputs)
	return de_organizeraboutenglishmissing3(inputs)
});
export { organizeraboutenglishmissing3 as "organizerAboutEnglishMissing" }